import './ResultsSummary.scss';

import { bem } from 'mission-control-common-components';
import React, { useMemo } from 'react';

import type { TagSheetSaveResult } from '../../types';
import { getSummary } from './utils';

const [block] = bem('results-summary');

export type ResultsSummaryProps = {
  lineItems: TagSheetSaveResult['lineItems'];
};

const ResultsSummary = ({ lineItems }: ResultsSummaryProps): React.JSX.Element => {
  const { adSummary, creativeSummary } = useMemo(() => getSummary(lineItems), [lineItems]);

  return (
    <div className={block()} data-testid="results-summary">
      <div>
        {adSummary.successCount} of {adSummary.totalCount} ads created successfully
      </div>
      <div>
        {creativeSummary.successCount} of {creativeSummary.totalCount} creatives created successfully
      </div>
    </div>
  );
};

export default ResultsSummary;
